<template>
    <vMaterialComponent :postList="postList" v-if="flag"></vMaterialComponent>
</template>
<script>
import vMaterialComponent from '../../listComponent/basicdata/material/materialComponent.vue';
export default {
    name: 'material',
    components: {
        vMaterialComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                code: true,
                name: true,
                quality_assurance_code: true,
                common_name: true,
                quality_assurance_name: true,
                tax_code: true,
                material_type_rid: true,
                dedicated_product_rid: true,
                dedicated_product_licence_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>